import { useParams } from "react-router-dom";
import PageContainer from "@/components/layout/page-container";
import { Heading } from "@/components/ui/heading";
import {
  useGetOpportunityApplications,
  useGetOpportunity,
} from "@/services/opportunities/queries";
import ApplicationsTable from "@/modules/opportunities/applications-table";
import { Skeleton } from "@/components/ui/skeleton";

export default function AppliedOpportunitiesPage() {
  const { id: opportunityId } = useParams<{ id: string }>();

  const { data: opportunityData, isLoading: isLoadingOpportunity } =
    useGetOpportunity(opportunityId || "", {
      enabled: !!opportunityId,
    });

  const { data: applicationsData, isLoading: isLoadingApplications } =
    useGetOpportunityApplications(
      opportunityId || "",
      {
        page: 1,
        limit: 20,
        sort: "createdAt:asc",
      },
      {
        enabled: !!opportunityId,
      }
    );

  const applications = applicationsData?.data || [];
  const pagination = applicationsData?.pagination;
  const opportunityTitle = opportunityData?.title || "Opportunity";

  if (!opportunityId) {
    return (
      <PageContainer scrollable={true}>
        <div className="flex h-full items-center justify-center">
          <div className="text-center">
            <h2 className="text-2xl font-semibold text-gray-900">
              Opportunity Not Found
            </h2>
            <p className="mt-2 text-gray-600">
              Please select a valid opportunity.
            </p>
          </div>
        </div>
      </PageContainer>
    );
  }

  return (
    <PageContainer scrollable={true}>
      <div className="h-full bg-white p-5">
        <div className="mb-3 flex items-center justify-between px-4 flex-wrap gap-2">
          <Heading
            title={opportunityTitle}
            //   description="View all applications for this opportunity"
          />
        </div>

        {isLoadingApplications || isLoadingOpportunity ? (
          <div className="flex items-center justify-center h-[60vh] p-6">
            <Skeleton className="w-full h-full rounded-lg" />
          </div>
        ) : (
          <div className="h-full space-y-4 bg-white py-3">
            <ApplicationsTable
              applications={applications}
              pagination={pagination}
              opportunityId={opportunityId}
            />
          </div>
        )}
      </div>
    </PageContainer>
  );
}
